import { useCallback,useEffect, useState } from "react"
import axios from "axios";
import { Helpers, Redux, Templates } from "@ora/recursos";
import { Chart } from "react-google-charts";
import fileDownload from "js-file-download";
const { baseUrl, baseUrlModule, localUrl } = Helpers.Url;
export default function Failies2({ origen, presentacion,grupos, date, language}) {
  const [state, setState] = useState({
    info:[],
    especies:[],
    infod:[],
    especiesd:[],
    infoy:[],
    especiesy:[],
    isLoad: false,
    select:''
  })

  const pruebaterm = useCallback(() => {

    var infopadre=[];

    var inf=["paises"];

    var infopaise=[];

    var infopresentacion=[];

    state.info.map((item)=>{
      inf.push(item.var_txt_description);
      infopaise.push(item.var_txt_description);

    })

    var unique=[...new Set(inf)];
    var uniquepais=[...new Set(infopaise)];
    infopadre.push(unique);


    var padrecont=[];
    state.especies.map((item)=>{
      var x =new Array(uniquepais.length);
      x.fill(0);
      x.unshift(item.especie+' ('+item.var_txt_name+')');
      uniquepais.map((it,index)=>{
        
        state.info.forEach((conten)=>{
          if(conten.especie==item.especie && conten.var_txt_description==it && conten.var_txt_name==item.var_txt_name){            
              x[index+1]=parseFloat(conten.cantidad);
          }

          
        })

        

      })
      infopadre.push(x);
      
      
    })



    console.log(infopadre);

    return infopadre;
    
    
  }, [state.info, state.especies])


  const pruebatermd = useCallback(() => {

    var infopadre=[];

    var inf=["paises"];

    var infopaise=[];

    var infopresentacion=[];

    state.infod.map((item)=>{
      inf.push(item.var_txt_description);
      infopaise.push(item.var_txt_description);

    })

    var unique=[...new Set(inf)];
    var uniquepais=[...new Set(infopaise)];
    infopadre.push(unique);


    var padrecont=[];
    state.especiesd.map((item)=>{
      var x =new Array(uniquepais.length);
      x.fill(0);
      x.unshift(item.especie+' ('+item.var_txt_name+')');
      uniquepais.map((it,index)=>{
        
        state.infod.forEach((conten)=>{
          if(conten.especie==item.especie && conten.var_txt_description==it && conten.var_txt_name==item.var_txt_name){            
              x[index+1]=parseFloat(conten.cantidad);
          }

          
        })

        

      })
      infopadre.push(x);
      
      
    })



    console.log(infopadre);

    return infopadre;
    
    
  }, [state.infod, state.especiesd])


  const pruebatermy = useCallback(() => {

    var infopadre=[];

    var inf=["paises"];

    var infopaise=[];

    var infopresentacion=[];

    state.infoy.map((item)=>{
      inf.push(item.var_txt_description);
      infopaise.push(item.var_txt_description);

    })

    var unique=[...new Set(inf)];
    var uniquepais=[...new Set(infopaise)];
    infopadre.push(unique);


    var padrecont=[];
    state.especiesy.map((item)=>{
      var x =new Array(uniquepais.length);
      x.fill(0);
      x.unshift(item.especie+' ('+item.var_txt_name+')');
      uniquepais.map((it,index)=>{
        
        state.infoy.forEach((conten)=>{
          if(conten.especie==item.especie && conten.var_txt_description==it && conten.var_txt_name==item.var_txt_name){            
              x[index+1]=parseFloat(conten.cantidad);
          }

          
        })

        

      })
      infopadre.push(x);
      
      
    })



    console.log(infopadre);

    return infopadre;
    
    
  }, [state.infoy, state.especiesy])

  const optionsrterm = useCallback(
    () => {
      return {
        title: "",
        chartArea: { width: "50%" },
        isStacked: true,
        hAxis: {
            title: language('total_exportaciones'),
            minValue: 0, 
        },
        vAxis: {
            title: language('especies'),
        },
        }
    },
    [origen, presentacion, grupos, date],
  )

  const download=useCallback(
    ()=>{

      axios({
        url: baseUrl('cites/reportes/filesExcelv4?origen='+origen+'&grupos='+grupos+'&presentacion='+presentacion+'&date='+date+'&d=4'),
        method: "GET",
        responseType: "blob", // Important
      }).then((response) => {
        // console.log(response)
        fileDownload(response.data, "CITES_descargas.xlsx");



      });

    },
  )

  

  

  useEffect(() => {
    axios.get(baseUrl('cites/reportes/infodashboardv4?origen='+origen+'&presentacion='+presentacion+'&grupos='+grupos+'&date='+date)).then((res) => {
      setState({
        info:res.data.info,
        especies:res.data.especies,
        infod:res.data.infod,
        especiesd:res.data.especiesd,
        infoy:res.data.infoy,
        especiesy:res.data.especiesy,

          isLoad: true
      });
    });
    return () => {
      setState({
        isLoad: false
      })
    }
  }, [origen, presentacion, grupos, date])
  return (
    <>
      { state.isLoad ? <>


      {state.info.length>0?<>

        <div className="card">
            <header class="card-header">
                <p class="card-header-title">
                    {language('dashboar_citesv4_tituloExport')}
                </p>
            </header>
            <div className="card-content">
                <div className="content">
                    <div className="columns">
                        <div className="column">
                        <Chart
                            chartType="BarChart"
                            width="100%"
                            height="500px"
                            data={pruebaterm()}
                            options={optionsrterm()}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>


        <div className="card">
            <header class="card-header">
                <p class="card-header-title">
                    {language('dashboar_citesv4_titulodestinos')}
                </p>
            </header>
            <div className="card-content">
                <div className="content">
                    <div className="columns">
                        <div className="column">
                        <Chart
                            chartType="BarChart"
                            width="100%"
                            height="500px"
                            data={pruebatermd()}
                            options={optionsrterm()}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div className="card">
            <header class="card-header">
                <p class="card-header-title">
                    {language('dashboar_citesv4_titulopresenta')}
                </p>
            </header>
            <div className="card-content">
                <div className="content">
                    <div className="columns">
                        <div className="column">
                        <Chart
                            chartType="BarChart"
                            width="100%"
                            height="500px"
                            data={pruebatermy()}
                            options={optionsrterm()}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div className="card">
          <footer class="card-footer">
                    <a href={localUrl('/reportes/especies/dashboardv4/completelistv4/?origen='+origen+'&grupos='+grupos+'&presentacion='+presentacion+'&date='+date)} target="_blank" class="card-footer-item "><button class="button is-success">{language('ver_lista_completa')}</button></a>
                    <div className="card-footer-item"><button class=" button is-success" onClick={() => download()} >{language('descargar_datos')}</button></div>
                  </footer>
        </div>

        </>:<>No existe ningún registro para el filtro aplicado</>}





      
      </>: <Helpers.Spinners.SpinLoaderStyle/> }
    </>
  )
}